(function ($, Drupal, once, drupalSettings) {
  'use strict';
  Drupal.behaviors.dlaParallax = {
    attach: function attach(context, settings) {

      var self = this;

      $(once('dla-processed', 'img', context)).each(function() {
        // On page load, detect all img tags that should have parallax effect applied to it
        self.detectParallax();
      });

    },

    detectParallax: function () {
      // Detect img tags that should have parallax effect
      const images = document.querySelectorAll('img.dla_parallax');
      new simpleParallax(images, {
        scale: 1.5
      });
    },
  };

})(jQuery, Drupal, once, drupalSettings);
